import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "flex mb8 flex-ac"
};
const _hoisted_3 = {
  key: 0,
  class: "img-box mr12 is-pointer"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "flex flex1 flex-sb",
  style: {
    "min-width": "0"
  }
};
const _hoisted_6 = {
  class: "flex flex-column",
  style: {
    "min-width": "0",
    "flex": "1"
  }
};
const _hoisted_7 = {
  class: "flex flex-ac mb4"
};
const _hoisted_8 = {
  class: "fs12 flex-shrink-0"
};
const _hoisted_9 = {
  key: 0,
  class: "line flex-shrink-0"
};
const _hoisted_10 = {
  key: 0,
  class: "ml8 type-btns flex flex-ac flex-jc"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "header-market-btn flex flex-ac is-pointer is-hover fs12 fc565960"
};
const _hoisted_13 = {
  class: "header-market-btn_text flex flex-ac"
};
const _hoisted_14 = {
  class: "iconfont icon-xiangshang"
};
const _hoisted_15 = {
  class: "iconfont icon-xiangxia-1"
};
const _hoisted_16 = {
  class: "fc565960 fs12 lh16 mr4"
};
const _hoisted_17 = {
  class: "fc212533 fs12 lh16"
};
const _hoisted_18 = {
  class: "custom-stocks_popover-price mt12"
};
const _hoisted_19 = {
  class: "fs21 fw700 mr4"
};
const _hoisted_20 = {
  class: "fw700"
};
const _hoisted_21 = {
  class: "ml20 mr4 fs18"
};
const _hoisted_22 = {
  class: "stock-total-market mt4 lh24 flex"
};
const _hoisted_23 = {
  class: "flex flex-ac mr12 fs12 fc565960"
};
const _hoisted_24 = {
  class: "fc212533 ml4 mr4 fs13"
};
const _hoisted_25 = {
  class: "fc888 fs13 mr4"
};
const _hoisted_26 = {
  class: "fc565960 fs12"
};
const _hoisted_27 = {
  class: "fc212533 fw500 fs13"
};
const _hoisted_28 = {
  key: 2
};
import { latestReport } from '@/jmHttp/api/marketStock.js';
import { queryCompanyDetailLatest, queryStockSameInfo } from '@/jmHttp/api/market';
import { addStockAttention, cancelStockAttention } from '@/apis/api/common';
import { ref, computed, defineAsyncComponent, nextTick, watch } from 'vue';
import { ElMessage, ElTooltip } from 'element-plus';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import { queryStockTradeDaily } from '@/apis/api/marketStock';
import { useRouter, useRoute } from 'vue-router';
import { customLink, formatCustomTime, isEnLang } from '@/utils/api';
import CustomTextWithTooltip from '../customTextWithTooltip.vue';
import { useCustomStocksPopoverRealtime } from './useCustomStocksPopoverRealtime';
export default {
  __name: 'index',
  props: {
    stock: {
      type: Object,
      default: () => ({})
    },
    hideAddStock: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const LineChart = defineAsyncComponent(() => import('./lineChart.vue'));
    const FinancialData = defineAsyncComponent(() => import('./financialData.vue'));
    const router = useRouter();
    const route = useRoute();
    const _useI18n = useI18n(),
      $t = _useI18n.t;
    const isThirdParty = route.path.includes('/thirdparty/');

    // 根据 marketType 获取市场名称（支持国际化）
    const getMarketName = marketType => {
      if (!marketType) return '';
      const marketTypeUpper = String(marketType).toLowerCase();

      // A股：sz, sh, bj
      if (['sz', 'sh', 'bj'].includes(marketTypeUpper)) {
        return $t('common.noun.a_share');
      }
      // 港股：hk
      if (marketTypeUpper === 'hk') {
        return $t('common.noun.h_share');
      }
      // 美股：us
      if (marketTypeUpper === 'us') {
        return $t('common.noun.us_share');
      }
      // 其他情况返回空字符串或原值
      return '';
    };

    // 接受attrs传递的参数
    const props = __props;
    // 有多个的存在
    const stockFullcodes = ref([]);
    const currentStockFullcode = ref(stockFullcodes.value[0] || props.stock.fullcode);
    const stockDetail = ref(null);
    const isEmpty = ref(false);
    const loading = ref(true);
    const tradeDailyLoading = ref(true);
    const stockReport = ref(null);
    const stockTradeDailyData = ref([]); // 近180日交易数据

    const height = ref('470px');

    // 行业名称是否溢出
    const industryNameRef = ref(null);
    const isIndustryNameOverflow = ref(false);

    // 检测行业名称是否溢出
    const checkIndustryNameOverflow = () => {
      nextTick(() => {
        if (industryNameRef.value) {
          isIndustryNameOverflow.value = industryNameRef.value.scrollWidth > industryNameRef.value.clientWidth;
        }
      });
    };

    // 监听 stockDetail 变化，检测行业名称是否溢出
    watch(() => {
      var _stockDetail$value;
      return (_stockDetail$value = stockDetail.value) === null || _stockDetail$value === void 0 ? void 0 : _stockDetail$value.industryName;
    }, () => {
      checkIndustryNameOverflow();
    });
    const currentStock = computed(() => {
      return stockFullcodes.value.find(item => item.fullCode === currentStockFullcode.value) || {};
    });
    const computedEndDate = computed(() => {
      return formatCustomTime(stockDetail.value.tradingDay, 'YYYY-MM-DD');
    });
    const currentMarketType = computed(() => {
      var _stockDetail$value2;
      return ((_stockDetail$value2 = stockDetail.value) === null || _stockDetail$value2 === void 0 ? void 0 : _stockDetail$value2.marketType) || props.stock.marketType;
    });
    const _useCustomStocksPopov = useCustomStocksPopoverRealtime({
        fullCodeRef: currentStockFullcode,
        tradeDailyDataRef: stockTradeDailyData,
        staticClosePriceRef: computed(() => {
          var _stockDetail$value3;
          return (_stockDetail$value3 = stockDetail.value) === null || _stockDetail$value3 === void 0 ? void 0 : _stockDetail$value3.closePrice;
        }),
        staticChangePctRef: computed(() => {
          var _stockDetail$value4;
          return (_stockDetail$value4 = stockDetail.value) === null || _stockDetail$value4 === void 0 ? void 0 : _stockDetail$value4.changePct;
        }),
        staticTotalMvRef: computed(() => {
          var _stockDetail$value5;
          return (_stockDetail$value5 = stockDetail.value) === null || _stockDetail$value5 === void 0 ? void 0 : _stockDetail$value5.totalMv;
        }),
        staticPeTtmRef: computed(() => {
          var _stockDetail$value6;
          return (_stockDetail$value6 = stockDetail.value) === null || _stockDetail$value6 === void 0 ? void 0 : _stockDetail$value6.peTtm;
        })
      }),
      resolveDisplayPrice = _useCustomStocksPopov.resolveDisplayPrice,
      resolveDisplayChangePct = _useCustomStocksPopov.resolveDisplayChangePct,
      displayTotalMv = _useCustomStocksPopov.displayTotalMv,
      displayPeTtm = _useCustomStocksPopov.displayPeTtm;
    const marketCap = computed(() => {
      if (!displayTotalMv.value) return '-';
      const divisor = isEnLang() ? 1e9 : 1e8;
      const price = (Number(displayTotalMv.value) / divisor).toFixed(2);
      return price.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
    const marketCapUnit = computed(() => isEnLang() ? 'B' : $t('selfSelected.tip.billion_unit'));
    const peTtm = computed(() => {
      if (!displayPeTtm.value && displayPeTtm.value !== 0) return '-';
      if (Number(displayPeTtm.value) < 0) return $t('selfSelected.tip.loss');
      return Number(displayPeTtm.value).toFixed(2);
    });
    const currencyUnit = computed(() => {
      if (currentMarketType.value === 'hk') {
        return 'HKD';
      }
      if (currentMarketType.value === 'us') {
        return 'USD';
      }
      return 'CNY';
    });

    // 排除市场区域
    const excludeMarket = ['us', 'hk', 'jpn'];

    // 港股、美股不财务数据
    const showPanel = computed(() => {
      return !excludeMarket.includes(currentMarketType.value);
    });
    const fetchQueryStockSameInfo = () => {
      loading.value = true;
      queryStockSameInfo({
        fullCode: props.stock.fullcode
      }).then(res => {
        var _stockFullcodes$value;
        if (!res || res.code !== '0') {
          return;
        }
        stockFullcodes.value = res.data || [];
        currentStockFullcode.value = ((_stockFullcodes$value = stockFullcodes.value[0]) === null || _stockFullcodes$value === void 0 ? void 0 : _stockFullcodes$value.fullCode) || props.stock.fullcode;
        fetchStockDetail();
      });
    };
    fetchQueryStockSameInfo();
    const fetchStockDetail = async () => {
      loading.value = true;
      const res = await queryCompanyDetailLatest({
        fullCode: currentStockFullcode.value
      });
      if (res.code !== '0' || !res.data) {
        return;
      }
      stockDetail.value = res.data;
      await fetchLastReport();
      await fetchStockTradeDaily();
      loading.value = false;
      if (!excludeMarket.includes(stockDetail.value.marketType)) {
        var _stockReport$value;
        height.value = (_stockReport$value = stockReport.value) !== null && _stockReport$value !== void 0 && _stockReport$value.expectedDisclosureDate ? '517px' : '470px';
      } else {
        var _stockReport$value2;
        height.value = (_stockReport$value2 = stockReport.value) !== null && _stockReport$value2 !== void 0 && _stockReport$value2.expectedDisclosureDate ? '337px' : '290px';
      }
    };
    const switchStockFullcode = item => {
      if (item.fullCode === currentStockFullcode.value) return;
      currentStockFullcode.value = item.fullCode;
      fetchStockDetail();
    };
    const handleCommand = e => {
      switchStockFullcode(e);
    };
    const visible = ref(false);
    const handleIconVisibleChange = status => {
      visible.value = status;
    };
    const handleAttendChange = status => {
      const action = status ? addStockAttention : cancelStockAttention;
      let payload = {
        id: stockDetail.value.fullCode
      };
      if (status) {
        payload = {
          fullCode: stockDetail.value.fullCode,
          name: stockDetail.value.shortName,
          sourceType: 1,
          type: 1
        };
      }
      action(payload).then(res => {
        if (res.code === 0) {
          stockDetail.value.isFollowed = status;
          ElMessage($t('selfSelected.tip.operation_success'));
        }
      });
    };
    const fetchLastReport = async () => {
      const res = await latestReport({
        fullCode: stockDetail.value.fullCode
      });
      if (res.code !== '0') return;
      stockReport.value = res.data;
    };

    // 近180日交易数据
    const fetchStockTradeDaily = async () => {
      tradeDailyLoading.value = true;
      const res = await queryStockTradeDaily({
        fullCode: stockDetail.value.fullCode,
        beginDate: dayjs().subtract(180, 'day').toISOString(),
        endDate: dayjs().toISOString()
      }).catch(() => {
        tradeDailyLoading.value = false;
      });
      tradeDailyLoading.value = false;
      if (!res || res.code !== 0) return;
      stockTradeDailyData.value = res.data.map(item => {
        const date = dayjs(item.tradingDay).add('8', 'hour').format('YYYY-MM-DD');
        return {
          ...item,
          date,
          timeIndex: item.timeIndex || date
        };
      });
    };
    const jumpStockDetailPage = isAchievement => {
      if (isThirdParty) {
        return;
      }
      const query = {
        fullCode: stockDetail.value.fullCode,
        type: 2
      };
      // 是否自动显示业绩期
      if (isAchievement) {
        query.activeName = 'Performance';
      }
      const page = router.resolve({
        name: 'stockDetail',
        query
      });
      customLink(page.href);
    };
    return (_ctx, _cache) => {
      var _stockDetail$value7, _stockDetail$value8, _stockDetail$value9, _stockDetail$value0, _stockDetail$value11, _stockDetail$value12, _stockDetail$value13;
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_skeleton = _resolveComponent("el-skeleton");
      const _directive_format = _resolveDirective("format");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", {
        ref: "popoverContainerRef",
        class: "custom-stocks_popover",
        style: _normalizeStyle({
          height: height.value
        })
      }, [stockDetail.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [(_stockDetail$value7 = stockDetail.value) !== null && _stockDetail$value7 !== void 0 && _stockDetail$value7.logo ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
        src: (_stockDetail$value8 = stockDetail.value) === null || _stockDetail$value8 === void 0 ? void 0 : _stockDetail$value8.logo,
        alt: "",
        onClick: jumpStockDetailPage
      }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
        class: "fs20 fw600 mr4 fc212533 is-hover is-pointer",
        onClick: jumpStockDetailPage
      }, [_createVNode(CustomTextWithTooltip, {
        text: (_stockDetail$value9 = stockDetail.value) === null || _stockDetail$value9 === void 0 ? void 0 : _stockDetail$value9.shortName
      }, null, 8, ["text"])]), !__props.hideAddStock ? (_openBlock(), _createBlock(_unref(ElTooltip), {
        key: 0,
        content: (_stockDetail$value0 = stockDetail.value) !== null && _stockDetail$value0 !== void 0 && _stockDetail$value0.isFollowed ? _unref($t)('selfSelected.button.cancel_optional') : _unref($t)('selfSelected.button.append_optional'),
        placement: "top"
      }, {
        default: _withCtx(() => {
          var _stockDetail$value1;
          return [_createElementVNode("i", {
            class: _normalizeClass(["icon iconfont icon-jia is-pointer fs12 lh14 text-center is-hover", {
              'icon-jian1': (_stockDetail$value1 = stockDetail.value) === null || _stockDetail$value1 === void 0 ? void 0 : _stockDetail$value1.isFollowed
            }]),
            onClick: _cache[0] || (_cache[0] = $event => {
              var _stockDetail$value10;
              return handleAttendChange(!((_stockDetail$value10 = stockDetail.value) !== null && _stockDetail$value10 !== void 0 && _stockDetail$value10.isFollowed));
            })
          }, null, 2)];
        }),
        _: 1
      }, 8, ["content"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "flex flex-ac stock-info-line",
        onClick: jumpStockDetailPage
      }, [_createElementVNode("span", _hoisted_8, _toDisplayString(stockDetail.value.code) + "." + _toDisplayString(stockDetail.value.marketType.toUpperCase()), 1), (_stockDetail$value11 = stockDetail.value) !== null && _stockDetail$value11 !== void 0 && _stockDetail$value11.industryName ? (_openBlock(), _createElementBlock("i", _hoisted_9)) : _createCommentVNode("", true), (_stockDetail$value12 = stockDetail.value) !== null && _stockDetail$value12 !== void 0 && _stockDetail$value12.industryName ? (_openBlock(), _createBlock(_unref(ElTooltip), {
        key: 1,
        effect: "dark",
        content: (_stockDetail$value13 = stockDetail.value) === null || _stockDetail$value13 === void 0 ? void 0 : _stockDetail$value13.industryName,
        placement: "top",
        disabled: !isIndustryNameOverflow.value
      }, {
        default: _withCtx(() => {
          var _stockDetail$value14;
          return [_createElementVNode("span", {
            ref_key: "industryNameRef",
            ref: industryNameRef,
            class: "fc212533 fs12 industry-name-text"
          }, _toDisplayString((_stockDetail$value14 = stockDetail.value) === null || _stockDetail$value14 === void 0 ? void 0 : _stockDetail$value14.industryName), 513)];
        }),
        _: 1
      }, 8, ["content", "disabled"])) : _createCommentVNode("", true)])]), stockFullcodes.value.length > 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [stockFullcodes.value.length <= 2 ? (_openBlock(), _createElementBlock("span", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockFullcodes.value, item => {
        return _openBlock(), _createElementBlock("span", {
          key: item.id,
          class: _normalizeClass(["is-hover is-pointer", {
            'is-active fc212533 fw600': item.fullCode === currentStockFullcode.value,
            fc565960: item.fullCode !== currentStockFullcode.value
          }]),
          onClick: $event => switchStockFullcode(item)
        }, _toDisplayString(getMarketName(item.marketType)), 11, _hoisted_11);
      }), 128))])) : (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        teleported: false,
        onCommand: handleCommand,
        onVisibleChange: handleIconVisibleChange
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockFullcodes.value, item => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: item.id,
              command: item,
              class: _normalizeClass({
                'is-active': item.fullCode === currentStockFullcode.value
              })
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(getMarketName(item.marketType)) + "(" + _toDisplayString(`${item.code}.${item.marketType.toUpperCase()}`) + ") ", 1)]),
              _: 2
            }, 1032, ["command", "class"]);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => {
          var _currentStock$value;
          return [_createElementVNode("span", _hoisted_12, [_createElementVNode("span", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(getMarketName((_currentStock$value = currentStock.value) === null || _currentStock$value === void 0 ? void 0 : _currentStock$value.marketType)), 1), _createVNode(_component_el_icon, {
            class: "icon-direction icon-bottom ml4 flex-shrink-0",
            size: 14
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [[_vShow, visible.value]]), _withDirectives(_createElementVNode("i", _hoisted_15, null, 512), [[_vShow, !visible.value]])]),
            _: 1
          })])])];
        }),
        _: 1
      }))], 64)) : _createCommentVNode("", true)])]), stockReport.value && stockReport.value.expectedDisclosureDate ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tooltip is-pointer",
        onClick: _cache[1] || (_cache[1] = $event => jumpStockDetailPage(true))
      }, [_cache[2] || (_cache[2] = _createElementVNode("i", {
        class: "iconfont icon-yejiqi-tongzhi fc3964E5 mr8"
      }, null, -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(_unref($t)('selfSelected.tip.next_performance_disclosure')), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(stockReport.value.expectedDisclosureDate || '-'), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("span", _hoisted_19, null, 512), [[_directive_format, _unref(resolveDisplayPrice), void 0, {
        price: true
      }]]), _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_20, [_createTextVNode(_toDisplayString(currencyUnit.value), 1)])), [[_directive_format, _unref(resolveDisplayChangePct), void 0, {
        pct: true,
        onlyColor: true
      }]]), _withDirectives(_createElementVNode("span", _hoisted_21, null, 512), [[_directive_format, _unref(resolveDisplayChangePct), void 0, {
        pct: true
      }]]), _createVNode(_unref(ElTooltip), {
        "show-after": 400,
        "hide-after": 0,
        effect: "dark",
        content: _unref($t)('selfSelected.tip.data_cutoff_date_tooltip') + computedEndDate.value,
        placement: "top"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
          class: "iconfont icon-shuoming fcc9cdd4 fs14"
        }, null, -1)]))]),
        _: 1
      }, 8, ["content"])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, [_createTextVNode(_toDisplayString(_unref($t)('selfSelected.tip.latest_total_market_value_label')) + " ", 1), _createElementVNode("span", _hoisted_24, _toDisplayString(marketCap.value), 1), _createElementVNode("span", _hoisted_25, _toDisplayString(marketCapUnit.value), 1), _createVNode(_unref(ElTooltip), {
        "show-after": 400,
        "hide-after": 0,
        effect: "dark",
        content: _unref($t)('selfSelected.tip.data_cutoff_date_tooltip') + computedEndDate.value,
        placement: "top"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("i", {
          class: "iconfont icon-shuoming fcc9cdd4 fs14"
        }, null, -1)]))]),
        _: 1
      }, 8, ["content"])]), _createElementVNode("span", _hoisted_26, [_createTextVNode(_toDisplayString(_unref($t)('selfSelected.tip.pe_ttm_label')) + " ", 1), _createElementVNode("span", _hoisted_27, _toDisplayString(peTtm.value), 1)])]), _withDirectives(_createVNode(_unref(LineChart), {
        "is-empty": !tradeDailyLoading.value && !stockTradeDailyData.value.length,
        data: stockTradeDailyData.value
      }, null, 8, ["is-empty", "data"]), [[_directive_loading, tradeDailyLoading.value && loading.value]]), showPanel.value ? (_openBlock(), _createBlock(_unref(FinancialData), {
        key: 1,
        "full-code": currentStockFullcode.value
      }, null, 8, ["full-code"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), loading.value && !stockDetail.value ? (_openBlock(), _createBlock(_component_el_skeleton, {
        key: 1,
        style: {
          "height": "100%"
        },
        rows: 11,
        animated: ""
      })) : _createCommentVNode("", true), isEmpty.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref($t)('selfSelected.tip.no_data')), 1)) : _createCommentVNode("", true)], 4);
    };
  }
};